import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const DoughnutChart = ({ color, valueToDisplay }) => {
  const setLeftMarginForValue = valueToDisplay => {
    if (valueToDisplay < 10) {
      return '50px';
    } else if (valueToDisplay >= 100) {
      return '40px';
    } else {
      return '46px';
    }
  };

  const parsedValueToDisplay =
    typeof(valueToDisplay) !== Number ? parseInt(valueToDisplay, 10) : valueToDisplay;

  const useStyles = makeStyles({
    container: {
      position: 'relative'
    },
    value: {
      position: 'absolute',
      color: color,
      zIndex: 10,
      marginLeft: setLeftMarginForValue(valueToDisplay),
      marginTop: '52px',
      fontWeight: 'bold'
    }
  });

  const classes = useStyles();

  return (
    <Typography className={ classes.container } component='div'>
      <Typography
        className={ classes.value }
        component='div'
      >
        { `${parsedValueToDisplay.toFixed(0)}%` }
      </Typography>
      <Typography component='div'>
        <Doughnut data = {
          { datasets: [
            {
              backgroundColor: [ color, '#E0E0E0' ],
              data: [
                parsedValueToDisplay,
                100 - (parsedValueToDisplay > 100 ? 100 : parsedValueToDisplay)
              ],
              borderWidth: [ 1, 1 ]
            }
          ]
          }
        }
        options ={
          {
            cutoutPercentage: 50,
            events: [],
            maintainAspectRatio: false,
            responsive: false
          }
        }
        width = { 116 }
        height = { 116 }
        />
      </Typography>
    </Typography>

  );
};

export default DoughnutChart;
